import { IMPORT_API } from "@/plugins/axios";

export function jsonParams(params) {
    let new_params = {};
    for (const key in params) {
        const element = params[key];
        if (typeof element == "object") {
            // eslint-disable-next-line no-const-assign
            element = JSON.stringify(element);
        }
        new_params[key] = element;
    }
    return new_params;
}

export async function deleteAll(route) {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "JWT " + localStorage.getItem("config_token")
            }
        };
        let res = await IMPORT_API.get(`/${route}/delete_all/`, config);
        return res;
    } catch (e) {
        console.warn(e);
    }
    return null;
}

export async function importJSON(route, data) {
    if (data) {
        data.map(record => {
            for (const key in record) {
                if (typeof record[key] == "string") record[key] = record[key].trim();
            }
            return record;
        });
    }
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "JWT " + localStorage.getItem("config_token")
            }
        };
        let res = await IMPORT_API.post(`/${route}/import_json/`, data, config);
        return res;
    } catch (e) {
        console.warn(e);
    }
    return null;
}

function mountDatasetDict(datasets = []) {
    let dict = {};
    datasets.forEach((dataset, index_ds) => {
        if (dataset)
            dataset.forEach(element => {
                const date_key = element.x;
                const value = element.y;
                if (!dict.hasOwnProperty(date_key)) {
                    dict[date_key] = {};
                }
                if (!dict[date_key].hasOwnProperty(index_ds)) {
                    dict[date_key][index_ds] = value;
                }
            });
    });
    return dict;
}
function genNullValues(dict = {}, quant = 0) {
    for (const date_time in dict) {
        if (dict.hasOwnProperty(date_time)) {
            const element = dict[date_time];
            for (let i = 0; i < quant; i++) {
                if (!element.hasOwnProperty(i)) element[i] = null;
            }
        }
    }
    return dict;
}
function separeDataset(dict = {}, quant = 0) {
    // eslint-disable-next-line no-unused-vars
    var new_datasets = [...Array(quant)].map(x => []);
    for (const date_time in dict) {
        if (dict.hasOwnProperty(date_time)) {
            const element = dict[date_time];
            for (const index_ds in element) {
                if (element.hasOwnProperty(index_ds)) {
                    const y = element[index_ds];
                    const x = date_time;
                    new_datasets[index_ds].push({ x: x, y: y });
                }
            }
        }
    }
    return new_datasets;
}
function sortDatasets(datasets = []) {
    datasets.forEach(dataset => {
        dataset.sort((a, b) => (a.x > b.x ? 1 : b.x > a.x ? -1 : 0));
    });
    return datasets;
}
export function generateFakeValues(datasets = []) {
    let quant = datasets.length;
    let dict = mountDatasetDict(datasets);
    dict = genNullValues(dict, quant);
    let new_datasets = separeDataset(dict, quant);
    new_datasets = sortDatasets(new_datasets);
    return new_datasets;
}
export function setFakeValues(datasets = []) {
    const quant = datasets.length;
    let datas = generateFakeValues(datasets.map(meas => meas.data));
    for (let i = 0; i < quant; i++) {
        datasets[i].data = datas[i];
    }
    return datasets;
}
/**
 * Method to transform number to a Brazillian pattern
 * @param str_val number to be converted
 * @returns String formated
 * @todo Implement a native Number method that does the same thing
 */
export function parseBRPattern(str_val = String()) {
    str_val = String(str_val);
    let number_val = parseFloat(str_val);
    let is_negative = false;
    if (number_val < 0) is_negative = true;
    str_val = str_val.replace("-", "");
    let arr = str_val.split(".");
    let aux = "";
    let ret = "";
    const len = arr[0].length;
    for (let i = len - 1; i >= 0; i--) {
        let index = len - i;

        aux = arr[0][i] + aux;
        if (index % 3 == 0 && i != 0) aux = "." + aux;
    }
    ret = arr.length > 1 ? `${aux},${arr[1]}` : aux;
    return is_negative ? "-" + ret : ret;
}


export function capitalize(text) {
    text = String(text);
    return text.charAt(0).toUpperCase() + text.substring(1);
}
/**
 * Validate if is a valid object (different than null and undefined)
 * then object contains keys and if its values when
 * converted to Boolean is "true"
 * @param {Object} object 
 * @param {String | Array} keyToValidate 
 * @returns true or false 
 */
export function validateObject(object, keyToValidate = "" | []) {
    const key = keyToValidate;
    if (!key) return Boolean(object);
    if (!object) return false; // check undefined and null

    if (Array.isArray(key)) {
        return key.every(k => k in object && Boolean(object[k]));
    } else {
        return Boolean(object[key]);
    }
}
/**
 * Generate randomly a hex color
 * @returns String representing Hex color
 */
export function randomColor() {
    return "#" + (((1 << 24) * Math.random()) | 0).toString(16);
}
/**
 * Validate if is a valid array (has length and its objects is valid)
 * @param {Array} array 
 * @param {String | Array} keyToValidate 
 * @param {Function} callback 
 * @returns true or false 
 */
export function validateObjectArray(array, keyToValidate = "" | [], callback = validateObject) {
    if (Array.isArray(array)) {
        return array.length > 0 && array.every(e => callback(e, keyToValidate));
    }
    return false;
}
